import { render, staticRenderFns } from "./BSSetInvoiceData.vue?vue&type=template&id=60521041"
import script from "./BSSetInvoiceData.vue?vue&type=script&lang=js"
export * from "./BSSetInvoiceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports